import environmentBase from './environment.base';

export const environment = {
  ...environmentBase,
  production: false,
  api: {
    url: 'https://api.ittikar-usd.dev.kubide.es/v1',
    // url: 'http://localhost:8877/v1',
    name: '59q2xdPPw',
    secret: 'onyzeRulez1!',
    apiKey: '4erc2lHiNnauu4Vl5BC6Qz'
  },
};

